const en = {
    login:{
        title:'I am the title',
    }
}
export default en;